// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/scripts/chunks/" + chunkId + ".js?id=" + "fce5007c6dadc164" + "";
};